import { TMarketplaceService } from '../marketplace-services';

export type TAccountantMarketplaceService = TMarketplaceService & {
  caFirmId: string;
  price: string;
};

export enum CARejectionReasons {
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
  OTHER = 'OTHER',
}

export type CorporationHasCAFirmAdditionalInfo = {
  didCallHappen?: boolean;

  reason?: CARejectionReasons[];

  comments?: string;

  hasReviewedFiscalYear?: boolean;
};

export type CAFirmAdditionalInformation = {
  services: CAFirmServices[];
  isOnboardingCompleted?: boolean;
};

export enum CAFirmServices {
  INCORPORATION = 'INCORPORATION',
  ODI = 'ODI',
  FDI = 'FDI',
  DIRECT_TAXES = 'DIRECT_TAXES',
  INDIRECT_TAXES = 'INDIRECT_TAXES',
  HR_AND_PAYROLL = 'HR_AND_PAYROLL',
  TRANSFER_PRICING = 'TRANSFER_PRICING',
  SALES_TAX = 'SALES_TAX',
}
